import React from 'react';

import { cn } from '@app/shared/utils/common';

interface ScrollAreaProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export function ScrollArea({ children, className, ...rest }: ScrollAreaProps) {
  return (
    <div
      className={cn('flex h-full flex-col overflow-auto pb-10 pt-3', 'scrollbar-hide', className)}
      {...rest}
    >
      {children}
    </div>
  );
}
